import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {useFetching} from "../../hooks/useFetching";
import {API_SOLUTIONS_CASINO_FIRST_SECTION} from "../../utils/consts";
import ApiSolutionsCasinoFirstSection from "../../services/SolutionsCasino/FirstSection";
import {useTranslation} from "react-i18next";
import {useWebPSupportCheck} from "react-use-webp-support-check";
import parse from "html-react-parser";
import {observer} from "mobx-react-lite";

import first_webp from "../../img/decision/first_bg.webp";
import first_jpg from "../../img/decision/first_bg.jpg";

const FirstSection = ({isLoading, setIsLoading}) => {
    const {t} = useTranslation()
    const location = useLocation()
    const supportsWebP = useWebPSupportCheck()

    const [data, setData] = useState();
    // const [data, setData] = useState({name: 'Готове комплексне рішення для грального бізнесу в Україні', content: '<p>Ми надаємо не лише програмне та апаратне забезпечення, але і повну організацію ігрового процесу у Вашому закладі. Наша компанія пропонує огляд продукту, який повністю відповідає вимогам законодавства та автоматизує більшість процесів Вашого закладу.&nbsp;</p>'});

    const [FunctionApiSolutionsCasinoFirstSection] = useFetching(async () => {
        try {
            const response = await ApiSolutionsCasinoFirstSection.getApiSolutionsCasinoFirstSection(API_SOLUTIONS_CASINO_FIRST_SECTION);
            setData(response.data);
        } catch {
            console.error('FunctionApiSolutionsCasinoFirstSection')
        }
    });

    useEffect(() => {
        FunctionApiSolutionsCasinoFirstSection();
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {data ? <div className="section" id="section0">
                {isLoading && <img
                    src={supportsWebP ? first_webp : first_jpg}
                    alt=""
                    onLoad={() => {
                        setIsLoading(false)
                    }}
                />}
                <div className="first_window" style={{backgroundImage: `url(${supportsWebP ? first_webp : first_jpg})`}}>
                    <div className="up_catalog">
                        <div className="title_block">
                            {data.name ? <h1>{data.name}</h1> : null}
                            {data.content ? parse(data.content) : null}
                        </div>
                    </div>
                    <div className="mouse_bottom">
                        <p>{t('Прогорнути')}</p>
                        <div className="line"></div>
                    </div>
                </div>
            </div> : null}
        </>
    );
};

export default observer(FirstSection);